// Daftar menu panel admin, dipakai oleh sidebar dan topbar.
// `level` berisi role yang boleh melihat menu tersebut.
const ALL_MODULES = [
  "admin",
  "kesehatan",
  "perhubungan",
  "pertanian",
  "perindag",
  "peternakan",
  "perikanan",
  "kependudukan",
];

export const menuGroups = [
  {
    label: "",
    items: [
      {
        path: "/dashboard",
        icon: "chart-pie",
        label: "Dashboard",
        level: ALL_MODULES,
      },
    ],
  },
  {
    label: "Kependudukan & Kesehatan",
    items: [
      {
        path: "/kependudukan",
        icon: "users",
        label: "Data Kependudukan",
        level: ["admin", "kependudukan"],
      },
      {
        path: "/kehamilan",
        icon: "person-pregnant",
        label: "Data Kehamilan",
        level: ["admin", "kesehatan"],
      },
      {
        path: "/persalinan",
        icon: "baby",
        label: "Data Persalinan",
        level: ["admin", "kesehatan"],
      },
      {
        path: "/stunting",
        icon: "child",
        label: "Data Stunting",
        level: ["admin", "kesehatan"],
      },
    ],
  },
  {
    label: "Layanan Kota",
    items: [
      {
        path: "/parking",
        icon: "parking",
        label: "Data Parkir",
        level: ["admin", "perhubungan"],
      },
    ],
  },
  {
    label: "Ekonomi & Pangan",
    items: [
      {
        path: "/pertanian",
        icon: "seedling",
        label: "Data Pertanian",
        level: ["admin", "pertanian"],
      },
      {
        path: "/harga-pasar",
        icon: "store",
        label: "Data Harga Pasar",
        level: ["admin", "perindag"],
      },
      {
        path: "/peternakan",
        icon: "cow",
        label: "Data Peternakan",
        level: ["admin", "peternakan"],
      },
      {
        path: "/perikanan",
        icon: "fish",
        label: "Data Perikanan",
        level: ["admin", "perikanan"],
      },
    ],
  },
  {
    label: "Akun",
    items: [
      {
        path: "/pengguna",
        icon: "user-shield",
        label: "Pengguna",
        level: ["admin"],
      },
      {
        path: "/profil",
        icon: "user",
        label: "Profil",
        level: ["user"],
      },
    ],
  },
];

const SUB_PAGES = [
  ["/import", "Import data"],
  ["/new", "Data baru"],
  ["/create", "Data baru"],
  ["/update", "Ubah data"],
  ["/detail", "Detail"],
];

export function isActivePath(itemPath, currentPath) {
  return currentPath === itemPath || currentPath.startsWith(itemPath + "/");
}

// Menu yang boleh dilihat role tertentu; grup tanpa isi dibuang.
export function visibleGroups(role) {
  const roles = [].concat(role || "user");
  return menuGroups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) =>
        item.level.some((level) => roles.includes(level))
      ),
    }))
    .filter((group) => group.items.length);
}

// Mengembalikan { group, label } untuk path yang sedang dibuka.
export function findCurrent(currentPath) {
  for (const group of menuGroups) {
    const item = group.items.find((i) => isActivePath(i.path, currentPath));
    if (!item) continue;
    const rest = currentPath.slice(item.path.length);
    const sub = SUB_PAGES.find(([segment]) => rest.startsWith(segment));
    return sub
      ? { group: item.label, label: sub[1] }
      : { group: group.label || "Panel Admin", label: item.label };
  }
  return { group: "Panel Admin", label: "" };
}
